import { PageProps } from 'gatsby';
import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { PrivacyPolicy } from '../features/privacy-policy/privacy-policy';

const PrivacyPolicyPage:React.FC<PageProps> =({location})=> {
  return (
    <Layout>
      <SEO
        location={location}
        keywords={[
          `privacy policy`,
          `policy`,
          `personal data`,
          `personal information`,
          `information use`,
          `third-party links`,
          `security`,
          `liability`,
        ]}
        title="Privacy Policy"
      />
      <PrivacyPolicy />
    </Layout>
  );
}

export default PrivacyPolicyPage;
